import { IconDefinition } from "./types";

/**
 * @deprecated Use `triangleExclamation` instead. This icon will be removed in a future version.
 */
const warning: IconDefinition = {
  iconName: "warning",
  width: 576,
  height: 512,
  svgPathData:
    "M315.4 33.9L533.7 432 560 480 16 480 42.3 432 260.6 33.9 288-16 315.4 33.9zM97.1 432L478.9 432 288 83.8 97.1 432zM316 396l-56 0 0-56 56 0 0 56zm-8.8-84l-38.4 0-12.8-120 64 0-12.8 120z",
  iconType: "fill",
  strokeWidth: 0,
  unicode: 0xf071,
};

export { warning };
